import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: {
      breadcrumb: {
        
      },
      label: { 
        resetApplication: "Reset application",
        resetApplicationConfirmation: "Please confirm that you want to close the current application.",
        user: "User",
        editApplicantForm: "Edit form information",
        dashboard: "Dashboard",
        endorser: "Endorser form",
        IdEndorser: "Identification of the endorser",
        missingDoc: "Missing document",
        gender: "Gender",
        man: "Man",
        woman: "Woman",
        other: "Other",
        infoUpload: "Upload information",
        title: "Rental",
        /*Step 0 */
        chooseRentalDate: "Choose the rental date",
        updateUnit: "Change unit",
        choose: "Choose",
        selected: "Selected",
        unitSelected: "Unit selected",
        addUnit: "Choose this unit",
        disponibility: "Disponibility",
        unitlabel:"Unit | Units",
        nbpieceslabel: "Rooms",
        price: "Price",
        rentalDate: "Rental date",
        search: "Search",
        tablesize: "Number of units :",
        hide: "Hide",
        show: "Show",
        properties: "Building list",
        bymonth: "By month",
        nbPiece: "Bedroom(s)",
        byrange: "Specific date",
        chooseStartDate: "Choose the rental date",
        chooseStartDateFirstOfTheMonth: "Choose the rental date. (1st of the month)",
        unitChoice: "Unit Choice",
        passwordChange: "Change your password",
        forgetPassword: "Forget password",
        submit: "Submit",
        fname: "First name",
        lname: "Last name",
        email: "Email",
        paswd: "Password",
        confPaswd: "Confirm password",
        language: "Language",
        register: "Register",
        login: "Login",
        copyright: "Société de gestion Cogir, all right reserved.",
        logout: "Logout",
        communication: "Language of communication",
        english: "English",
        french: "French",
        unitinfo: "Unit information",
        floor: "Floor",
        surface: "Surface",
        orientation: "Orientation",
        /*Step 1 */
        fiche : {
          /* building */
          step1Title: "Rental form",
          title: "Rental request",
          IdImmeuble : "Identification of the building",
          nomImeuble: "Building Name",
          adresseImmeuble: "Building Address",
          appartement: "Apartment",
          loyer: "Lease",
          period: "Period",
          from: "From",
          to: "to",
          rooms: "Rooms",
          inclusions: "Inclusions",
          otherServices: "Other Services",
          promotions: "Promotions",
          /*candidat*/
          Idprospect: "Identification of the candidate",
          fname: "First name",
          lname: "Last name",
          email: "Email",
          cell: "Cell",
          phone: "Phone",
          birthdate: "Birthdate",
          chooseAddress: "Find your address",
          addressCandidate: "Current address",
          civic: "Civic number",
          street: "Street",
          locality: "City",
          app: "App #",
          province: "Province",
          country: "Country",
          postal: "Postal Code",
          civilStatus: [{value: null, text: "Civil Status *"}, {value: 1, text: "Single"}, {value: 2, text: "Married"},
          {value: 3, text: "Common-law partner"}, {value: 4, text: "Widower"} , {value: 5, text: "Divorced"} , {value: 6, text: "Separate"} ],
          childPossession: "Child / Children",
          yes: "Yes",
          no: "No",
          age: "Age",
          experienceCogir: "Rental experience with Cogir",
          experienceQuestion : "Have you ever lived in a building managed by Cogir ?",
          buildingName: "Building Name",
          completeAddress: "Complete address",
          rentedMonth: "Rent / month",
          startDate: "Start date",
          endDate: "End date",
          contactName: "Name of Owner / Concierge",
          contactPhone: "Phone number",
          /*Job information */
          jobInformation: "Job information",
          currentSituations: [{value: null, text: "Current situation *"}, {value: 1, text: "Employed"}, {value: 2, text: "Employment Insurance"},
          {value: 3, text: "Welfare"}, {value: 4, text: "CNESST"} , {value: 5, text: "Retirement income"} , {value: 6, text: "Other"} ],
          otherSituation: "Other situation",
          emplInsurance: "Employment Insurance",
          welfare: "Welfare",
          CNESST: "CNESST",
          retIncome: "Retirement income",
          otherIncome: "Other income",
          employerName: "Employer name/City",
          rhDirector: "R.H director",
          employerPhone: "Employer phone",
          position: "Position",
          annualSalary: "Annual salary",
          otherAmount: "Amount",
          totalIncome: "Total income",
          student: "Student",
          studentQuestion: "Are you a student ?",
          school: "School/University",
          pretBourse: "Loan/Scholarship",
          banque: "Bank",
          bankName: "Bank name",
          bankAddress: "Bank branch address",
          personalRef: "Personal references",
          refName: "Full name",
          refAddress: "Complete address",
          refCity: "City",
          refCell: "Cell",
          refPhone: "Phone",
          consent: "Consent"
        },
        /*Step 2 */
        signatureBox: "Sign your name in the box below",
        yourSignature: "Your signature",
        /*Step 3 */
        submitApplication: "Submit your documents",
        addApplication: "Add an application",
        Id: "Identification",
        proof: "Proof of income",
        applicantType: "Applicant type",
        otherDoc: "Other documents",
        choosefile: "Choose a file",
        clearField: "Empty the fields",
        addApplicant: "Add",
        removeApplicant: "Remove",
        principalApplicant: "Principal applicant",
        coloc: "Roomate",
        creditStatus: "Application status",
      },
      info: {
        nbOfMissingDoc: "You have reached the limit on the number of missing documents you can submit. Contact a rental agent for more information.",
        tempUser: "An email has been sent to you to activate your account. If you haven't received it, try again later.",
        accountActivated: "Your account has been activated successfully",
        accountSuccess: "An email has been sent to you to validate your account. If you haven't received it, please check your spam folder.",
        noUnit: "No unit for this request",
        paswdValidation: "Your password is not valid",
        wrongPassword: "Wrong password",
        errorgeneric: "An error has occurred",
        errorCaptcha: "You did not pass the reCAPTCHA challenge",
        required: "This field is required",
        email: "This email address is not valid",
        maxLength: "This field is limited to {0} characters",
        minLength: "This field must contain at least {0} characters",
        paswdInt: "The password must be alphanumeric and contain between 8 and 20 characters and at least one letter, one number and one uppercase.",
        userExist: "This user is already register with this email. You should try to login or recovered your password if you lost it.",
        sameAs: "The password is not the same,",
        noExistingUser: "No user was found with this email.",
        succesGeneric: "Your request has been send succesfully.",
        noUserToken: "There is no active user associate with this link.",
        linkExpired: "Your link is no longer active.",
        ageRequired: "You must provide a value for each field",
        ageNumeric: "You must provide a numeric value",
        ageRange: "Age must be between 1 and 120",
        numeric: "This field must be a numeric value",
        minValue: "Minimum value is {0}",
        maxValue: "Maximum value is {0}",
        invalidDateRange: "Invalid date range",
        prp: "*** Please note that our Company is subject to and complies with the Personal Information Protection and Electronic Documents Act (LPRPSP).",
        declaration: "I, the undersigned, declare that all of the above information as truthful and hereby authorize any person (private investigative agent, credit officer, my employer and "+
        "current or past landlord) to divulge my personal information to the lessor, his representative or agent in order to evaluate the present rental proposal or for any "+
        "amendment, renewal or extension of my tenancy. It is clearly understood that all information given on this application or obtained by the landlord and / or his "+
        "representatives is confidential. Furthermore, I agree to sign the lease form provided if it is accepted within the next 10 days.",
        optIn: "By signing below, I hereby accept to receive any and all notices, correspondances, procedures or any and all other documents to be served or notified via my e-mail address.",
        errorSignature: "You must draw your signature",
        limitNumberOfFiles: "You cannot upload more than 3 files", 
        limitNumberOfFilesMissingDoc: "You cannot upload more files than the number of required documents", 
        requiredId: "You must provide a photocopy of an identification document. (driver's license, passport, etc.)",
        requiredProof: "You must provide a photocopy of proof of income. (pay stub, letter of employment, etc.)",
        requiredDoc: "File type supported (.pdf, .jpg or .png)",
        invalidFileType: "File type not supported (.pdf, .jpg or .png) or file too large (max 4 mb)",
        invalidFileSize: "File size limit is 4 mb",
        invalidFileTypeCsv: "Invalid file type (csv)",
        invalidFileTypeFormat: "Invalid file format",
        waitingForAnalysis: "We have received your information. We will analyze your application. An agent will communicate with you. Thank you for choosing Cogir.",
        activeSession: "A session is active for this email address. Please contact a rental agent for more details.",
        unitNotAvailable: "This unit is no longer available. You can change the unit by going back to step 1",
        missingDoc: "Enter the missing documents in the corresponding fields.",
        endorserClosed: "There is already an endorser for this application.",
        submitDoc: "File successfully submitted",
        nbOfUnitAvailable: "We found {0} unit(s) matching your search criteria.",
        registerOrLogin: "You must create an account or identify yourself to see the available units",
        chooseUnit: "Complete the required fields and press submit to see a list of available unit(s)."
      }
    },
    fr: {
      breadcrumb: {
          
      },
      label: { 
        resetApplication: "Réinitialiser l'application",
        resetApplicationConfirmation: "Svp confirmer que vous voulez fermer l'application en cours.",
        user: "Utilisateur",
        editApplicantForm: "Modifier les informations du formulaire",
        dashboard: "Centre de contrôle",
        endorser: "Formulaire de l'endosseur",
        IdEndorser: "Identification de l'endosseur",
        missingDoc: "Documents manquants",
        gender: "Genre",
        man: "Homme",
        woman: "Femme",
        other: "Autre",
        infoUpload: "Information pour le téléversement",
        title: "Location",
        updateUnit: "Changer l'unité",
        choose: "Choisir",
        selected: "Sélectionner",
        chooseRentalDate: "Choisir la date de location",
        unitSelected: "Unité choisie",
        addUnit: "Choisir cette unité",
        disponibility: "Disponibilité",
        unitlabel:"Unité | Unités",
        nbpieceslabel: "Pièces",
        price: "Prix",
        rentalDate: "Date de location",
        search: "Chercher",
        tablesize: "Nombre d'unités dans le tableau : ",
        hide: "Ouvrir",
        show: "Fermer",
        properties: "Liste des propriétés",
        bymonth: "Par mois",
        nbPiece: "Nb pièce(s)",
        byrange: "Date spécifique",
        chooseStartDate: "Choisir la date de location",
        chooseStartDateFirstOfTheMonth: "Choisir la date de location. (1er du mois)",
        unitChoice: "Choisir une unité",
        passwordChange: "Changer votre mot de passe",
        forgetPassword: "Mot de passe oublié",
        submit: "Soumettre",
        fname: "Prénom",
        lname: "Nom",
        email: "Courriel",
        paswd: "Mot de passe",
        confPaswd: "Confirmer le mot de passe",
        language: "Langue",
        register: "Créer un compte",
        login: "Se connecter",
        copyright: "Société de gestion Cogir, tous droits réservés.",
        logout: "Déconnexion",
        communication: "Langue de communication",
        english: "Anglais",
        french: "Français",
        unitinfo: "Information sur l'unité",
        floor: "Étage",
        surface: "Surface",
        orientation: "Orientation",
        fiche : {
          /* building */
          step1Title: "Formulaire de location",
          title: "Demande de location",
          IdImmeuble : "Identification de l'Immeuble",
          nomImeuble: "Nom de l'immeuble",
          adresseImmeuble: "Adresse de l'immeuble",
          appartement: "Appartement",
          loyer: "Loyer",
          period: "Période",
          from: "Du",
          to: "au",
          rooms: "Nb de pièces",
          inclusions: "Inclusions",
          otherServices: "Autres Services",
          promotions: "Promotions",
          /* candidat */
          Idprospect: "Identification du candidat",
          fname: "Prénom",
          lname: "Nom de famille",
          email: "Courriel",
          cell: "Cell",
          phone: "Téléphone",
          birthdate: "Date de naissance",
          chooseAddress: "Trouver votre adresse",
          addressCandidate: "Adresse actuelle",
          civic: "Numéro civique",
          street: "Rue",
          locality: "Ville",
          app: "App #",
          province: "Province",
          country: "Pays",
          postal: "Code postal",
          civilStatus: [{value: null, text: "État civil"}, {value: 1, text: "Célibataire"}, {value: 2, text: "Marié(e)"},
          {value: 3, text: "Conjoint(e) de fait"}, {value: 4, text: "Veuf(ve)"} , {value: 5, text: "Divorcé(e)"} , {value: 6, text: "Séparé(e)"} ],
          childPossession: "Enfant(s)",
          yes: "Oui",
          no: "Non",
          age: "Âge",
          experienceCogir: "Expérience(s) de location avec Cogir",
          experienceQuestion : "Avez-vous déjà habité dans un immeuble géré par Cogir ?",
          completeAddress: "Adresse complète",
          buildingName: "Nom de la propriété",
          rentedMonth: "Loyer/mois",
          startDate: "Date de début",
          endDate: "Date de fin",
          duration: "Durée",
          contactName: "Nom du Propriétaire/Concierge",
          contactPhone: "Téléphone",
          /*Job information */
          jobInformation: "Job information",
          currentSituations: [{value: null, text: "Situation actuelle"}, {value: 1, text: "En emploi"}, {value: 2, text: "Assurance emploi"},
          {value: 3, text: "Aide sociale"}, {value: 4, text: "CNESST"} , {value: 5, text: "Revenu de retraite"} , {value: 6, text: "Autre"} ],
          otherSituation: "Autre situation",
          emplInsurance: "Assurance emploi",
          welfare: "Aide sociale",
          CNESST: "CNESST",
          retIncome: "Revenu de retraite",
          otherIncome: "Autre revenu",
          employerName: "Nom de l'employeur/ville",
          rhDirector: "Directeur R.H",
          employerPhone: "Téléphone employeur",
          position: "Poste occupé",
          annualSalary: "Salaire annuel",
          otherAmount: "Montant",
          totalIncome: "Revenus totaux",
          student: "Étudiant",
          studentQuestion: "Êtes-vous étudiant ?",
          school: "École/Université",
          pretBourse: "Prêt/Bourse",
          banque: "Banque",
          bankName: "Nom de la banque",
          bankAddress: "Adresse de la succursale bancaire",
          personalRef: "Références personnelles",
          refName: "Nom complet",
          refAddress: "Adresse complète",
          refCity: "Ville",
          refPhone: "Téléphone",
          refCell: "Cell",
          refPhone1: "Cell",
          refPhone2: "Téléphone",
          consent: "Consentement"
        },
        signatureBox: "Signer votre nom dans la boîte ci-dessous",
        yourSignature: "Votre signature",
        /*Step 3 */
        submitApplication: "Soumettre vos documents",
        addApplication: "Ajouter une application",
        Id: "Pièce d'identité",
        proof: "Preuve de revenu",
        bondform: "Formulaire de cautionnement",
        otherDoc: "Autre document",
        applicantType: "Type de demandeur",
        choosefile: "Choisir un fichier",
        clearField: "Vider les champs",
        addApplicant: "Ajouter",
        removeApplicant: "Enlever",
        principalApplicant: "Demandeur principal",
        coloc: "Colocataire",
        creditStatus: "Statut de la demande",
      },
      info: {
        nbOfMissingDoc: "Vous avez atteint la limite du nombre de documents manquants que vous pouvez soumettre. Communiquez avec un agent de location pour plus d'information.",
        tempUser: "Un courriel vous a été envoyé pour activer votre compte. Si vous ne l'avez pas reçu, veuillez réessayer plus tard.",
        accountActivated: "Votre compte a été activé avec succès",
        accountSuccess: "Un courriel vous a été envoyé afin d'activer votre compte. Si vous ne l'avez pas reçu, veuillez vérifier le dossier des courriels indésirables.",
        noUnit: "Aucune unité pour cette requête",
        paswdValidation: "Votre mot de passe n'est pas valide",
        wrongPassword: "Mauvais mot de passe",
        errorgeneric: "Une erreur s'est produite",
        errorCaptcha: "Vous n'avez pas réussi le challenge reCAPTCHA",
        required: "Ce champs est requis",
        email: "Cette adresse courriel n'est pas valide",
        maxLength: "Ce champ est limité à {0} charactères",
        minLength: "Ce champ doit contenir {0} charactères au minimum",
        paswdInt: "Le mot de passe doit être alphanumérique et contenir entre 8 et 20 charactères et au minimum une lettre, un chiffre et une majuscule.",
        userExist: "Cet utilisateur est déjà enregistré avec ce courriel. Vous pouvez essayer de vous connecter ou de récupérer votre mot de passe si vous l'avez perdu.",
        sameAs: "Le mot de passe n'est pas identique.",
        noExistingUser: "Aucun utilisateur n'a été trouvé avec ce courriel.",
        succesGeneric: "Votre demande a été soumise avec succès",
        noUserToken: "Il n'y a aucun utilisateur associé à ce lien.",
        linkExpired: "Votre lien n'est plus actif. Vous devez soumettre une nouvelle demande si vous voulez changer votre mot de passe.",
        ageRequired: "Vous devez inscrire une valeur dans chaque champs",
        ageNumeric: "Les valeurs doivent être numériques",
        ageRange: "L'âge doit être compris entre 1 et 120 ans",
        numeric: "Ce champ doit contenir une valeur numérique",
        minValue: "La valeur minimum est {0}",
        maxValue: "La valeur maximum est {0}",
        invalidDateRange: "L'interval de date n'est pas valide",
        prp: "*** Veuillez noter que notre Société est assujettie et respecte la Loi sur la protection des renseignements personnels et les documents électroniques (LPRPSP).",
        declaration: "Je, soussigné, déclare que les renseignements fournis sont véridiques et j’autorise tout agent de renseignements personnels, bureau de crédit, mon employeur, mon "+
        "propriétaire actuel et/ou précédent et ma banque à confirmer et à divulguer des renseignements personnels me concernant au locateur, à son représentant et/ou à son "+
        "mandataire afin d’évaluer la présente offre de location ou pour tout amendement, renouvellement ou prolongation de ladite location. Il est clairement entendu que les "+
        "informations inscrites sur le présent document et celles obtenues par le locateur, son représentant et/ou son mandataire sont confidentielles. De plus, je m’engage à signer "+
        "un bail pour ledit logement à condition que cette demande soit acceptée dans les 10 jours. ",
        optIn: "Par la présente, je consens à recevoir tout avis, correspondance, "+
        "procédure ou tout autre document du locateur pour valoir notification et/ou signification à mon adresse courriel.",
        errorSignature: "Vous devez fournir une signature",
        limitNumberOfFiles: "Vous ne pouvez pas téléverser plus de 3 fichier(s)",
        limitNumberOfFilesMissingDoc: "Vous ne pouvez pas téléverser plus fichiers que de documents manquants",  
        invalidFileType: "Type de fichier non supporté (.pdf, .jpg ou .png) ou fichier trop volumineux (max 4 mb)",
        requiredId: "Vous devez fournir une photocopie d'une preuve d'identité avec photo. (permis de conduire, passeport, etc.)",
        requiredProof: "Vous devez fournir une photocopie d'une preuve de revenu. (talon de paie, lettre d'embauche, etc.)",
        requiredDoc: "Types de fichier supportés (.pdf, .jpg or .png)",
        invalidFileSize: "La taille maximum d'un fichier est de 4 mb",
        invalidFileTypeCsv: "Type de fichier non supporté (csv)",
        invalidFileTypeFormat: "Le format du fichier est invalide",
        waitingForAnalysis: "Nous avons bien reçu vos informations. Nous allons procéder à l'analyse de votre candidature. Un agent va communiquer avec vous. Merci d'avoir choisi Cogir.",
        activeSession: "Une session est active pour cette adresse courriel. Svp contacter un agent de location pour plus de détails.",
        unitNotAvailable: "Cette unité n'est plus disponible. Vous pouvez changer d'unité en retournant à l'étape 1.",
        missingDoc: "Entrez les documents manquants dans les champs correspondants.",
        endorserClosed: "Il y a déjà un endosseur pour cette application.",
        submitDoc: "Ficher(s) soumis avec succès",
        nbOfUnitAvailable: "Nous avons trouvé {0} unité(s) correspondant à vos critères de recherche.",
        registerOrLogin: "Vous devez créer un compte ou vous identifiez pour voir les unités disponibles.",
        chooseUnit: "Compléter les champs requis et appuyer sur soumettre pour voir une liste d'unité(s) disponible(s)."
      }
    }
  }
})
